/* eslint-disable no-unused-expressions */
/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import React, { useRef } from "react";
import "../../App.css";
import DataTable from "react-data-table-component";
import axios from "axios";
import { endpoints } from "../../services/apiurl";
import { withRouter } from "react-router";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Button, Card, TextField } from "@mui/material";
import moment from "moment";
import { InfinitySpin } from "react-loader-spinner";

class SubscribeUsLeads extends React.Component {
  // Constructor
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      DataisLoaded: false,
      restaurent: [],
      restaurent_outlet: [],
      restro_id: "",
      start_date: "",
      rest: "",
      end_date: "",
      type: "",
      currentPage: 1,
      page:1,
      totalPages: 1,
      total: "",
      totalsubscribe:0,
      per_page: 10,
      booking_status: "",
      booking_type: "",
      queryStartDate: "",
      queryEndDate: "",
      queryFilterBy: "",
      queryRestroId: "",
      hitFilterBtn:0,
      isFilterValid: true,
    };

    this.fetchData = this.fetchData.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handlePerRowsChange = this.handlePerRowsChange.bind(this);
    this.fetchQueryParam = this.fetchQueryParam.bind(this);
    this.QueryFeedbackFilter = this.QueryFeedbackFilter.bind(this);
  }

  componentDidMount() {
    //this.fetchData();
    this.fetchRestData();
    this.fetchOutletData();
    this.fetchQueryParam();
  }

  componentDidUpdate(prevProps) {
    // Check if the query parameters have changed
    if (this.props.location.search !== prevProps.location.search) {
      this.fetchQueryParam();
    }
  }


  fetchQueryParam() {
    const query = new URLSearchParams(this.props.location.search);
    const start_date = query.get("start_date");
    const end_date = query.get("end_date");
    const restro_id = query.get("restro_id");
    if (start_date && end_date) {
      this.setState({ start_date, end_date, rest: restro_id, hitFilterBtn: 1 }, () => {
        this.QueryFeedbackFilter(start_date, end_date, restro_id);
      });
    } else if (restro_id) {
      this.setState({ rest: restro_id, hitFilterBtn: 1 }, () => {
        this.QueryFeedbackFilter(start_date, end_date, restro_id);
      });
    } else if (start_date && end_date && restro_id) {
      this.setState({ start_date, end_date, rest: restro_id, hitFilterBtn: 1 }, () => {
        this.QueryFeedbackFilter(start_date, end_date, restro_id);
      });
    } else {
      if (this.state.hitFilterBtn === 0) {
        this.fetchData(this.state.page, this.state.per_page);
      }
    }
  }
  


  QueryFeedbackFilter(startDate, endDate, RestroId, page = this.state.page, per_page = this.state.per_page) {
    if (!startDate && !endDate && !RestroId) {
      alert("Please Select Any Filter");
      return;
    }
  
    if (startDate && !endDate) {
      alert("Please select end date");
      return;
    }
  
    if (endDate && !startDate) {
      alert("Please select start date");
      return;
    }
  
    var end_date = endDate;
    var start_date = startDate;
    var rest = RestroId ? RestroId : "";
    var type = "subscribe";
  
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let user_id = b.id;
    let restro_id = rest ? rest : b.restro_id;
  
    axios
      .post(endpoints.contactusFilter, {
        start_date,
        end_date,
        type,
        user_id,
        restro_id,
        page,
        per_page
      })
      .then((response) => {
        this.setState({
          items: response.data.data,
          totalsubscribe: response.data.total,
          totalPages: response.data.total_pages,
          DataisLoaded: true,
        });
      });
  }
  
  

  fetchData(page,per_page) {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let restro_id = b.restro_id;

    axios
      .post(endpoints.getSubscribeUs, {
        restro_id,
        page,
        per_page
      })
      .then((response) => {
        this.setState({
          items: response.data.data,
          totalsubscribe: response.data.total,
          totalPages: response.data.total_pages,
          DataisLoaded: true,
          // booking_status:response.data.data.booking_status
        });
      });
  }

  handlePageChange(page) {
    if (this.state.hitFilterBtn === 0) {
      this.fetchData(page, this.state.per_page);
    } else if (this.state.isFilterValid) {
      this.QueryFeedbackFilter(
        this.state.start_date,
        this.state.end_date,
        this.state.rest,
        page,
        this.state.per_page
      );
    }
  }
  
  handlePerRowsChange(newPerPage, page) {
    this.setState({ per_page: newPerPage }, () => {
      if (this.state.hitFilterBtn === 0) {
        this.fetchData(page, newPerPage);
      } else if (this.state.isFilterValid) {
        this.QueryFeedbackFilter(
          this.state.start_date,
          this.state.end_date,
          this.state.rest,
          page,
          newPerPage
        );
      }
    });
  }


  fetchRestData() {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);

    axios.post(endpoints.getRestaurentsDropDown, {}).then((response) => {
      this.setState({
        restaurent: response.data.data,
        total: response.data.total,
        totalPages: response.data.total_pages,
        DataisLoaded: true,
      });
      // console.log(response.data);
    });
  }

  fetchOutletData() {
    let a = localStorage.getItem("user");
    let b = JSON.parse(a);
    let user_id = b.id;
    let restro_id = b.restro_id;

    axios
      .post(endpoints.getOutlet, {
        restro_id,
        user_id,
      })
      .then((response) => {
        this.setState({
          restaurent_outlet: response.data.data,
          total: response.data.total,
          totalPages: response.data.total_pages,
          DataisLoaded: true,
        });
      });
  }

  render() {
    const { DataisLoaded } = this.state;
    const a = this.state.items;

    const b = this.state.total;

    const links = this.state.restaurent;
    const outlets = this.state.restaurent_outlet;
    const user = localStorage.getItem("user");
    const user_data = JSON.parse(user);
    this.restro_id = user_data.restro_id;
    const dates = new Date();
    const month = JSON.stringify(dates.getMonth() + 1);
    const date = JSON.stringify(dates.getDate());

    const columns = [
      {
        selector: (row) => row.email,
        cellExport: (row) => row.email,
        sortable: true,
      },

      {
        selector: (row) =>
          row.created_at == "CREATED AT"
            ? "CREATED AT"
            : moment(row.created_at).format("YY-MM-DD HH:mm:ss"),
        cellExport: (row) =>
          row.created_at == "CREATED AT"
            ? "CREATED AT"
            : moment(row.created_at).format("YY-MM-DD HH:mm:ss"),
        sortable: true,
      },
      {
        selector: (row) => row.restro_name,
        cellExport: (row) => row.restro_name,
        sortable: true,
      },
    ];

    const onSubmit = async (e) => {
      this.filterfetch(e);
    };
    const bFilter = () => {
      const { start_date, end_date, rest } = this.state;
    
      // Check if at least one filter is selected
      if (!start_date && !end_date && !rest) {
        alert("Please Select Any Filter");
        this.setState({ isFilterValid: false });
        return;
      }
    
      this.setState({ isFilterValid: true, hitFilterBtn: 1 });
    
      // Fetch the data with the selected filters
      this.QueryFeedbackFilter(
        start_date,
        end_date,
        rest
      );
    
      this.props.history.replace({ search: "" });
    };


    const onStartChange = (e) => {
      // this.start_date = e.target.value
      this.setState({ start_date: e.target.value });
      //console.log(this.state.start_date , this.end_date, this.type, this.rest)
    };
    const onEndChange = (e) => {
      // this.end_date = e.target.value
      this.setState({ end_date: e.target.value });
    };


    const onRestChange = (e) => {
      this.setState({ rest: e.target.value });
      // this.rest = e.target.value
    };
    const c = [
      {
        name: "NAME",
        email: "EMAIL",
        mobile: "NUMBER",
        message: "MESSAGE",
        restro_name: "RESTAURANT",
        created_at: "CREATED AT",
      },
    ];

    const data = c.concat(a);
    const tableData = {
      columns,
      data,
    };

    if (!DataisLoaded)
      return (
        <div className="spinner">
          <InfinitySpin
            visible={true}
            width="200"
            color="#fbaa1a"
            ariaLabel="infinity-spin-loading"
          />
        </div>
      );

    return (
      <>
        <h2>Subscribe Us Leads</h2>
        <Card className="px-3 py-3">
          <form
            className="ui form"
            onSubmit={(e) => onSubmit(e)}
            encType="multipart/form-data"
          >
            <div className="row">
              <div className="col-md-3">
                <label>Start Date</label>
                <br />
                <TextField
                  fullWidth
                  id="start_date"
                  label="Start Date"
                  type="date"
                  name="start_date"
                  value={this.state.start_date}
                  place="Start Date"
                  onChange={(e) => onStartChange(e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>
              <div className="col-md-3">
                <label>End Date</label>
                <br />
                <TextField
                  fullWidth
                  id="end_date"
                  label="End Date"
                  type="date"
                  name="end_date"
                  place="End Date"
                  value={this.state.end_date}
                  onChange={(e) => onEndChange(e)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>

              {this.restro_id === 0 ? (
                <div className="col-md-3">
                  <label>Restaurant</label>
                  <select
                    name="rest"
                    required
                    className="form-control"
                    value={this.state.rest}
                    onChange={(e) => onRestChange(e)}
                  >
                    <option value="">Select Restaurant</option>
                    {links.map((e, key) => {
                      return (
                        <option key={key} value={e.id}>
                          {e.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              ) : (
                ""
              )}
              <div className="col col-3">
                <div className="mt-5 text-center">
                  <Button
                    className="w-50"
                    onClick={() => bFilter()}
                    style={{ color: "white" }}
                    variant="contained"
                    size="medium"
                  >
                    Filter
                  </Button>
                </div>
              </div>
            </div>
          </form>
        </Card>
        <div className="row mt-2">
          <DataTableExtensions {...tableData} filter={false}>
            <DataTable
              defaultSortField="id"
              pagination
              paginationServer
              highlightOnHover
              paginationTotalRows={this.state.totalsubscribe}
              onChangePage={this.handlePageChange}
              onChangeRowsPerPage={this.handlePerRowsChange}
              progressPending={!this.state.DataisLoaded}
            />
          </DataTableExtensions>
        </div>
      </>
    );
  }
}
export default withRouter(SubscribeUsLeads);
